module.exports = __webpack_public_path__ + "img/Speedjunkies.616ff568.jpg";